export const VAULT_PATIENT_LIST_REQUEST = 'VAULT_PATIENT_LIST_REQUEST';
export const VAULT_PATIENT_LIST_SUCCESS = 'VAULT_PATIENT_LIST_SUCCESS';
export const VAULT_PATIENT_LIST_FAIL = 'VAULT_PATIENT_LIST_FAIL';
export const VAULT_PATIENT_LIST_RESET = 'VAULT_PATIENT_LIST_RESET';

export const VAULT_PATIENT_LIST_BY_IDS_REQUEST = 'VAULT_PATIENT_LIST_BY_IDS_REQUEST';
export const VAULT_PATIENT_LIST_BY_IDS_SUCCESS = 'VAULT_PATIENT_LIST_BY_IDS_SUCCESS';
export const VAULT_PATIENT_LIST_BY_IDS_FAIL = 'VAULT_PATIENT_LIST_BY_IDS_FAIL';
export const VAULT_PATIENT_LIST_BY_IDS_RESET = 'VAULT_PATIENT_LIST_BY_IDS_RESET';

export const VAULT_PATIENT_DETAILS_REQUEST = 'VAULT_PATIENT_DETAILS_REQUEST';
export const VAULT_PATIENT_DETAILS_SUCCESS = 'VAULT_PATIENT_DETAILS_SUCCESS';
export const VAULT_PATIENT_DETAILS_FAIL = 'VAULT_PATIENT_DETAILS_FAIL';
export const VAULT_PATIENT_DETAILS_RESET = 'VAULT_PATIENT_DETAILS_RESET';

// Present only because DynamicFormSP dispatches *_CREATE_RESET on mount. Vault participants are
// minted by VaultPatientRepository.ResolveAsync when a Patient is saved, never authored here,
// so there is no createVaultPatient action to go with these.
export const VAULT_PATIENT_CREATE_RESET = 'VAULT_PATIENT_CREATE_RESET';

export const VAULT_PATIENT_UPDATE_REQUEST = 'VAULT_PATIENT_UPDATE_REQUEST';
export const VAULT_PATIENT_UPDATE_SUCCESS = 'VAULT_PATIENT_UPDATE_SUCCESS';
export const VAULT_PATIENT_UPDATE_FAIL = 'VAULT_PATIENT_UPDATE_FAIL';
export const VAULT_PATIENT_UPDATE_RESET = 'VAULT_PATIENT_UPDATE_RESET';

export const VAULT_PATIENT_DTO_REQUEST = 'VAULT_PATIENT_DTO_REQUEST';
export const VAULT_PATIENT_DTO_SUCCESS = 'VAULT_PATIENT_DTO_SUCCESS';
export const VAULT_PATIENT_DTO_FAIL = 'VAULT_PATIENT_DTO_FAIL';
export const VAULT_PATIENT_DTO_RESET = 'VAULT_PATIENT_DTO_RESET';

// Protocol §5.3 withdrawal — a dedicated multi-row action, not a field write.
export const VAULT_PATIENT_OPT_OUT_REQUEST = 'VAULT_PATIENT_OPT_OUT_REQUEST';
export const VAULT_PATIENT_OPT_OUT_SUCCESS = 'VAULT_PATIENT_OPT_OUT_SUCCESS';
export const VAULT_PATIENT_OPT_OUT_FAIL = 'VAULT_PATIENT_OPT_OUT_FAIL';
export const VAULT_PATIENT_OPT_OUT_RESET = 'VAULT_PATIENT_OPT_OUT_RESET';

export const VAULT_PATIENT_BACKFILL_REQUEST = 'VAULT_PATIENT_BACKFILL_REQUEST';
export const VAULT_PATIENT_BACKFILL_SUCCESS = 'VAULT_PATIENT_BACKFILL_SUCCESS';
export const VAULT_PATIENT_BACKFILL_FAIL = 'VAULT_PATIENT_BACKFILL_FAIL';
export const VAULT_PATIENT_BACKFILL_RESET = 'VAULT_PATIENT_BACKFILL_RESET';

export const VAULT_PATIENT_UPLOAD_BATCHES_REQUEST = 'VAULT_PATIENT_UPLOAD_BATCHES_REQUEST';
export const VAULT_PATIENT_UPLOAD_BATCHES_SUCCESS = 'VAULT_PATIENT_UPLOAD_BATCHES_SUCCESS';
export const VAULT_PATIENT_UPLOAD_BATCHES_FAIL = 'VAULT_PATIENT_UPLOAD_BATCHES_FAIL';

export const VAULT_PATIENT_SUB_STUDIES_REQUEST = 'VAULT_PATIENT_SUB_STUDIES_REQUEST';
export const VAULT_PATIENT_SUB_STUDIES_SUCCESS = 'VAULT_PATIENT_SUB_STUDIES_SUCCESS';
export const VAULT_PATIENT_SUB_STUDIES_FAIL = 'VAULT_PATIENT_SUB_STUDIES_FAIL';

// VaultSubStudy CRUD
export const VAULT_SUB_STUDY_LIST_REQUEST = 'VAULT_SUB_STUDY_LIST_REQUEST';
export const VAULT_SUB_STUDY_LIST_SUCCESS = 'VAULT_SUB_STUDY_LIST_SUCCESS';
export const VAULT_SUB_STUDY_LIST_FAIL = 'VAULT_SUB_STUDY_LIST_FAIL';
export const VAULT_SUB_STUDY_LIST_RESET = 'VAULT_SUB_STUDY_LIST_RESET';

export const VAULT_SUB_STUDY_LIST_BY_IDS_REQUEST = 'VAULT_SUB_STUDY_LIST_BY_IDS_REQUEST';
export const VAULT_SUB_STUDY_LIST_BY_IDS_SUCCESS = 'VAULT_SUB_STUDY_LIST_BY_IDS_SUCCESS';
export const VAULT_SUB_STUDY_LIST_BY_IDS_FAIL = 'VAULT_SUB_STUDY_LIST_BY_IDS_FAIL';
export const VAULT_SUB_STUDY_LIST_BY_IDS_RESET = 'VAULT_SUB_STUDY_LIST_BY_IDS_RESET';

export const VAULT_SUB_STUDY_DETAILS_REQUEST = 'VAULT_SUB_STUDY_DETAILS_REQUEST';
export const VAULT_SUB_STUDY_DETAILS_SUCCESS = 'VAULT_SUB_STUDY_DETAILS_SUCCESS';
export const VAULT_SUB_STUDY_DETAILS_FAIL = 'VAULT_SUB_STUDY_DETAILS_FAIL';
export const VAULT_SUB_STUDY_DETAILS_RESET = 'VAULT_SUB_STUDY_DETAILS_RESET';

export const VAULT_SUB_STUDY_DTO_REQUEST = 'VAULT_SUB_STUDY_DTO_REQUEST';
export const VAULT_SUB_STUDY_DTO_SUCCESS = 'VAULT_SUB_STUDY_DTO_SUCCESS';
export const VAULT_SUB_STUDY_DTO_FAIL = 'VAULT_SUB_STUDY_DTO_FAIL';
export const VAULT_SUB_STUDY_DTO_RESET = 'VAULT_SUB_STUDY_DTO_RESET';

export const VAULT_SUB_STUDY_CREATE_REQUEST = 'VAULT_SUB_STUDY_CREATE_REQUEST';
export const VAULT_SUB_STUDY_CREATE_SUCCESS = 'VAULT_SUB_STUDY_CREATE_SUCCESS';
export const VAULT_SUB_STUDY_CREATE_FAIL = 'VAULT_SUB_STUDY_CREATE_FAIL';
export const VAULT_SUB_STUDY_CREATE_RESET = 'VAULT_SUB_STUDY_CREATE_RESET';

export const VAULT_SUB_STUDY_UPDATE_REQUEST = 'VAULT_SUB_STUDY_UPDATE_REQUEST';
export const VAULT_SUB_STUDY_UPDATE_SUCCESS = 'VAULT_SUB_STUDY_UPDATE_SUCCESS';
export const VAULT_SUB_STUDY_UPDATE_FAIL = 'VAULT_SUB_STUDY_UPDATE_FAIL';
export const VAULT_SUB_STUDY_UPDATE_RESET = 'VAULT_SUB_STUDY_UPDATE_RESET';

export const VAULT_SUB_STUDY_DELETE_REQUEST = 'VAULT_SUB_STUDY_DELETE_REQUEST';
export const VAULT_SUB_STUDY_DELETE_SUCCESS = 'VAULT_SUB_STUDY_DELETE_SUCCESS';
export const VAULT_SUB_STUDY_DELETE_FAIL = 'VAULT_SUB_STUDY_DELETE_FAIL';
export const VAULT_SUB_STUDY_DELETE_RESET = 'VAULT_SUB_STUDY_DELETE_RESET';

// Paginated VaultPatients enrolled in one sub-study
export const VAULT_SUB_STUDY_PATIENTS_REQUEST = 'VAULT_SUB_STUDY_PATIENTS_REQUEST';
export const VAULT_SUB_STUDY_PATIENTS_SUCCESS = 'VAULT_SUB_STUDY_PATIENTS_SUCCESS';
export const VAULT_SUB_STUDY_PATIENTS_FAIL = 'VAULT_SUB_STUDY_PATIENTS_FAIL';
export const VAULT_SUB_STUDY_PATIENTS_RESET = 'VAULT_SUB_STUDY_PATIENTS_RESET';
